<template>
  <div class="app">
    <Registro v-if="view=='registro'" :noframe="true" />
    <Messaggi v-if="view=='messaggi'" :noframe="true" />
    <ChangeCalendar v-if="view=='editcalpers'" :noframe="true" />
    <ModRel v-if="view=='modrel'" :noframe="true" />
    <AppHeader fixed v-if="!view" :class="enac ? 'enac' : (green ? 'green' : 'ecfop')">
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="Ecfop Logo">
        <img class="navbar-brand-full" :src="enac ? 'img/logo-white-enac.jpg' : (green ? 'img/logo_green.png' : 'img/logo-white.jpg')" height="99%" alt="Logo" style='background-color: white;'>
      </b-link>
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body" v-if="!view">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <!-- !!!!! la ":key" serve per forzare l'aggiornamento di un component se questo rimane lo stesso fra url diverse -->
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter v-if="!view || true">
      <!--footer-->
      <div>
        <span class="ml-1">&copy; 2025 Ropel Software S.n.c. - {{version}}</span>
      </div>
      <div class="ml-auto">
      </div>
    </TheFooter>
  </div>
</template>

<script>
//import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import { API } from "@/api.js";
import Registro from '@/views/Registro'
import Messaggi from '@/views/Messaggi'
import ChangeCalendar from '@/views/ChangeCalendar'
import ModRel from '@/views/ModRel'

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    Registro,
    ModRel,
    Messaggi,
    ChangeCalendar,
  },
  data () {
  console.log("RUN MODE 1:",process.env.NODE_ENV)
    return {
      nav: [],
    }
  },
  created: async function () {
      console.log("ROUTE:",window.location,window.location.pathname)
      if(this.view){
        // chiamato da swone, prendo il token
        //sessionStorage.setItem(window.keyname, null);
        console.log("DCGET:",window.location.origin + '/getToken.php')
        var ret = await this.$http.get(window.location.origin + '/getToken.php?rnd='+Math.random())
        console.log("DCRET:",ret)
        sessionStorage.setItem(window.keyname, ret.data);
      } else {

      }
      var menu = await API.getmenu(this,0,0)
      
      if(window.DEBUG) {
        menu.push({icon: "fa fa-calendar", name: "EDIT CAL", url: "editcalpers"})
        menu.push({icon: "fa fa-book", name: "MESSAGGI", url: "messaggi"})
        menu.push({icon: "fa fa-book", name: "REGISTRO", url: "registro"})
        menu.push({icon: "fa fa-book", name: "Mod.Relaz.", url: "modrel"})
        menu.push({icon: "fa fa-book", name: "Mod.Relazionali", url: "showmodrelaz"})
        menu.push({icon: "fa fa-book", name: "Soft Skills", url: "softskillspers"})
        menu.push({icon: "fa fa-book", name: "Assenze", url: "assenze"})
      }
      
      this.nav = menu
      console.log("MENUITEMS:",this.nav)
  },
  computed: {
    enac(){
      return window.ENAC
    },
    green(){
      return window.GREEN
    },
    version(){
      return window.VERSION
    },
    view() {
      var url = new URL(window.location.href);
      var app = url.searchParams.get("app");
      return app
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>
<style scoped>
  a.navbar-brand {
    justify-content: inherit;
  }
  header.ecfop {
        background-color: #064F86;
  }
  header.enac {
        background-color: #7ea77e;
  }
  header.green {
        background-color: #87d22d;
  }
</style>
